import { type FC } from 'react';
import Share24 from './Share24.tsx';

type ShareProps = {
    variation: '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Share24,
};

const Share: FC<ShareProps> = ({ variation, ...props }) => {
    const variationKey = `Share${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        return null;
    }

    return <Icon {...props} />;
};

export default Share;
